import styled from 'styled-components';

const StyledAttendanceDetailsContainer = styled.div``;

export default StyledAttendanceDetailsContainer;
